import React from 'react';
import { TextArea } from '@progress/kendo-react-inputs';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { FloatingLabel } from '@progress/kendo-react-labels';
import { TEXT_AREA_MAX_LENGTH } from 'utility/enumerations';
// @ts-ignore
import styles from './form.module.scss';

interface CustomInputProps extends FieldRenderProps {
  label: any,
  required: boolean,
  // eslint-disable-next-line react/require-default-props
  max?: number
}

export const CustomTextarea = (props: CustomInputProps) => {
  const textArea = (
    <div>
      <TextArea
        className={`${props.className ?? ''}${props.readOnly ? styles.readOnly : ''}`}
        value={props.value}
        onChange={props.onChange}
        required={props.required}
        valid={!props.required || !props.visited || props.value}
        onBlur={props.onBlur}
        readOnly={props.readOnly}
        maxLength={props?.max ?? TEXT_AREA_MAX_LENGTH}
        aria-label={props.label}
      />
    </div>
  );

  return (
    <>
      {props.label && (
      /* @ts-ignore */
      <FloatingLabel
        label={props.label}
        editorId={props.id}
        editorValue={props.value}
        editorValid={props.valid}
        editorDisabled={props.disabled}
      >
        {textArea}
      </FloatingLabel>
      )}
      {!props.label && (
      <div>
        {textArea}
      </div>
      )}
    </>
  );
};
